import styles from './navbar.module.scss';
import NavItem from './navItem';
// Icons
import cpLogo from '../../assets/logo/cp.svg';
import { 
  PatientsIcon, 
  BillingsIcon, 
  ProvidersIcon, 
  CalenderIcon 
} from '../icons/icons';

import { useNavigate, useLocation } from 'react-router-dom';
import ProfileDropdown from '../ProfileDropdown/ProfileDropdown';

const navLinks = [
  {
    to: '/dashboard',
    text: 'Patients',
    icon: PatientsIcon,
  },
  {
    to: '/dashboard/billing',
    text: 'Billing',
    icon: BillingsIcon,
  },
  {
    to: '/provider',
    text: 'Providers',
    icon: ProvidersIcon,
  },
  {
    to: '/appointments',
    text: 'Appointments',
    icon: CalenderIcon,
  },
];

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className={styles['navbar-root']}>
      <div className={styles['navbar-container']}>
        <div onClick={() => navigate('/dashboard')}>
          <img src={cpLogo} alt="cp-logo" />
        </div>

        <div className={styles['navbar-nav-items']}>
          {navLinks.map((link) => (
            <NavItem
              key={link.to}
              to={link.to}
              text={link.text}
              icon={link.icon}
              isActive={location.pathname === link.to}
            />
          ))}
        </div>

        <div className={styles['navbar-profile-section']}>
          <ProfileDropdown />
        </div>
      </div>
    </div>
  );
};

export default Navbar;
